import { wrapRootElement as wrap } from './root-wrapper';
import './src/styles/global.css';
import 'normalize.css';
// require('prismjs/themes/prism-tomorrow.css');

export const wrapRootElement = wrap;
